import React, { Component } from "react";
import { TextBox } from "../../Components/InputElements";
import axios from "axios";
import Cookies from "js-cookie";
import { ConfigContext } from "../../Context/ConfigContext";
import PageTitle from "../../Components/PageTitle";
import Swal from "sweetalert2";
import { withTranslation } from "react-i18next";
import { Link, Navigate } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { currentDateAndTime, decodeData } from "../../Constants/constants";
import TooltipComponent from "../../Components/TooltipComponent";

const LetterHead = withTranslation()(
  class LetterHead extends Component {
    static contextType = ConfigContext;

    constructor(props) {
      super(props);
      this.state = {
        letterhead: [],
        fileName: "",
        company_letter_head_id: 0,
        fileSize: "",
        selectedImage: null,
        theInputKey: "inkey100",
        uploadLoading: false,
        isPriceUpdated: false,
        isValidExcelFile: false,
        company_letter_head_name: "",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        decodedData: [],
      };
    }

    handleDrop = (acceptedFiles) => {
      this.setState((prevState) => ({
        letterhead: [...prevState.letterhead, ...acceptedFiles],
      }));
    };
    getBack=()=>{
      window.history.back();
  }
    componentDidMount() {
      this.setState({ loadingList: true }, () => {
        const { company_letter_head_id } = this.props.params || {};
        if (company_letter_head_id) {
          this.GetLetterHeadInfo(company_letter_head_id);
        }
      });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
      goBack = () => {
        window.history.back();
      };

    handleSubmit = async (e) => {
      e.preventDefault();
      if (this.state.letterhead.length === 0 && this.state.company_letter_head_id === 0) {
        alert("File is required");
        return;
      }

      const { apiURL, apiHeaderFile } = this.context;
      const headers = apiHeaderFile;
      var markings = [this.state.top, this.state.bottom, this.state.left, this.state.right]
      const formData = new FormData();
      formData.append("letterhead", this.state.letterhead[0]);
      formData.append("markings", markings);
      formData.append("company_letter_head_name", this.state.company_letter_head_name);
      formData.append('date',currentDateAndTime());
      if (this.state.company_letter_head_id !== 0) {
        formData.append("company_letter_head_id", this.state.company_letter_head_id);
      }

      try {
        const response = await axios.post(`${apiURL}Masters/CreateLetterHead`, formData, { headers });
        const { success, message } = response.data;
        const alertType = success ? 'success' : 'error';

        this.setState({
          letterhead: [],
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
        });
        this.handleDeleteImage();

        Swal.fire({
          title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
          text: message,
          icon: alertType
        });
        // document.getElementById('changePage').click();
        this.getBack()
      } catch (error) {
        console.error("Error occurred:", error);
        Swal.fire({
          title: 'Error',
          text: 'An error occurred while submitting the data.',
          icon: 'error'
        });
      }
    };

    GetLetterHeadInfo = async (company_letter_head_id) => {
      try {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        const response = await axios.get(`${apiURL}Masters/GetLetterHeadInfo`, {
          params: { company_letter_head_id },
          headers
        });

        const data = response.data;

        if (data.success && data.data.length > 0) {
          const letterInfo = data.data[0];
          const [top, bottom, left, right] = letterInfo.markings.split(",").map((val) => val.trim());

          this.setState({
            company_letter_head_id: letterInfo.company_letter_head_id || 0,
            selectedImage: letterInfo.letterhead_url,
            top,
            bottom,
            left,
            right,
            company_letter_head_name: letterInfo.company_letter_head_name,
          });

          console.log("Data loaded successfully: ", letterInfo);
        } else {
          console.error("No data found for the specified letterhead ID.");
        }
      } catch (error) {
        console.error("Error fetching letterhead info:", error);
      }
    };



    resetFileInput = () => {
      // Clear the input value
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = null;
      }
      // Keep the same key for the input
      let randomString = Math.random().toString(36);
      this.setState({
        theInputKey: randomString,
      });
    };
    handleInputChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,

      });

    };

    handleFileChange = (e) => {
      const file = e.target.files[0];

      if (file) {
        const { name, size, type } = file;
        const fileSizeInMB = size / (1024 * 1024);
        const fileExtension = name.split(".").pop().toLowerCase();

        if (
          type.startsWith("image/") &&
          fileExtension.match(/(jpg|jpeg|png)$/)
        ) {
          this.setState({
            selectedImage: URL.createObjectURL(file),
            fileName: name,
            fileSize: `${fileSizeInMB.toFixed(2)} MB`,
            isValidExcelFile: false,
            letterhead: [file],
          });
        } else {
          this.setState({
            isValidExcelFile: true,
          });
          console.error("Invalid file type or extension");
        }
      }
    };


    
    handleDeleteImage = () => {
      this.setState({
        selectedImage: null,
        fileName: "",
        fileSize: "",
        letterhead: [],
        isValidExcelFile: false,
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
      });
      this.resetFileInput();
    };
    render() {
      return (
        <>
          <div className="main-content">
            <div className="page-content">
              <div className="container-fluid">
                <br />
                <PageTitle title={"Letter Head"} primary={`Home`} />
                <div className=" card p-2">
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <h4 className="card-title mb-0 flex-grow-1">
                        {this.state.company_letter_head_id ? "Update Letter Head" : "Create Letter Head"}
                    </h4>
                    <TooltipComponent name="Back" position="bottom">
                    <button className="btn btn-success btn-sm" 
                      onClick={this.goBack}
                    >
                        <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                    </button>
                    </TooltipComponent>
                  </div>
                </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="card">
                        <div className="card-header justify-content-center align-items-center d-flex">
                          <h3 className="d-flex justify-content-center h4 align-items-center">
                            Submit Your Letter Here.
                          </h3>
                        </div>
                        <div className="card-body">
                          <div>
                            <div className="d-flex justify-content-between align-items-center ml-4">
                              <div className="d-flex justify-content-around align-items-center">
                                <h5 className="fs-13 mb-1">
                                  Note*:{" "}
                                  <span className="text-danger">
                                    Kindly provide your Letter in JPG format.
                                  </span>{" "}
                                </h5>
                              </div>
                            </div>
                            <div className="mt-3 mb-3">
                              <TextBox label={"Letter Head Name"} hint={"Enter Letter Head Name"} type="text" id="company_letter_head_name" name="company_letter_head_name" value={this.state.company_letter_head_name}
                                change={this.handleInputChange} />
                            </div>
                            <div className="dropzone dz-clickable d-flex justify-content-center flex-column align-items-center">
                              <label
                                htmlFor="fileInput"
                                className="dz-message needsclick d-flex justify-content-center flex-column align-items-center cursor-pointer"
                              >
                                <div className="mb-3">
                                  <i className="display-4 text-muted ri-upload-cloud-2-fill"></i>
                                </div>
                                <h5>Drop files here or click to upload.</h5>
                              </label>
                            </div>
                            <input
                              type="file"
                              id="fileInput"
                              key={this.state.theInputKey || ""}
                              onChange={this.handleFileChange}
                              style={{ marginTop: "10px", display: "none" }}
                              accept="image/jpeg"
                            />

                            <div className="d-flex justify-content-between mt-3">
                              <label
                                type="submit"
                                className="btn btn-primary btn-label waves-effect waves-light"
                                style={{ marginTop: "10px" }}
                                htmlFor="fileInput"
                              >
                                <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                Chosse File
                              </label>
                              <button
                                type="button"
                                className="btn btn-success btn-label waves-effect waves-light"
                                style={{ marginTop: "10px" }}
                                onClick={this.handleSubmit}
                              >
                                <i className="ri-save-line label-icon align-middle fs-16 me-2" />
                                {this.state.company_letter_head_id !== 0 ? 'Update' : 'Submit'}
                              </button>

                              {/* <button className="btn btn-success btn-label waves-effect waves-light d-none"

                        //  to={"/SignatoryMaster"}
                                        onClick={()=> this.getBack()} >
                                <i className="ri-save-line label-icon align-middle fs-16 me-2" />
                                </button> */}
                              <Link
                                type="button"
                                id="changePage"
                                className="btn btn-success btn-label waves-effect waves-light d-none"
                                to={'/LetterHeadList'}
                              >
                                <i className="ri-save-line label-icon align-middle fs-16 me-2" />
                                go
                              </Link>
                            </div>

                            <input
                              type="file"
                              id="fileInput"
                              key={this.state.theInputKey || ""}
                              onChange={this.handleFileChange}
                              style={{ marginTop: "10px", display: "none" }}
                              accept="image/jpeg"
                            />

                            <div></div>
                            <ul
                              className="list-unstyled mb-0"
                              id="dropzone-preview"
                              style={{
                                visibility:
                                  this.state.fileName === ""
                                    ? "hidden"
                                    : "visible",
                              }}
                            >
                              <li
                                className="mt-2 dz-processing dz-error dz-complete"
                                id="dropzone-preview-list"
                              >
                                <div className="border rounded">
                                  <div className="d-flex p-2">
                                    <div className="flex-shrink-0 me-3">
                                      <div className="avatar-sm bg-light rounded">
                                        {this.state.isValidExcelFile ? (
                                          <i
                                            className="ri-alert-fill"
                                            style={{
                                              position: "absolute",
                                              color: "red",
                                              marginLeft: 20,
                                              marginTop: 10,
                                            }}
                                          ></i>
                                        ) : (
                                          <div></div>
                                        )}
                                        <center>
                                          <i
                                            className="ri-image-fill"
                                            style={{
                                              fontSize: 28,
                                              color: "green",
                                            }}
                                          ></i>
                                        </center>
                                      </div>
                                    </div>
                                    <div className="flex-grow-1">
                                      <div className="pt-1">
                                        <h5
                                          className="fs-13 mb-1"
                                          data-dz-name=""
                                        >
                                          {this.state.fileName}
                                        </h5>
                                        <p
                                          className="fs-13 text-muted mb-0"
                                          data-dz-size=""
                                        >
                                          <strong>{this.state.fileSize}</strong>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                      <button
                                        data-dz-remove=""
                                        onClick={this.handleDeleteImage}
                                        className="btn btn-sm btn-outline-danger"
                                      >
                                        <i className="ri-delete-bin-line"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8" >
                      <div className="card" style={{ height: '350mm',width: '220mm', background: this.state.selectedImage && '#f5f5f5' }} >
                        <div className="card-header" >
                          <div
                            className="row mt-1 d-flex align-items-center"
                            style={{ marginTop: "-20px" }}
                          >
                            <div className="col-md-2">
                              <h4 className="card-title mb-0">Preview Tab</h4>
                            </div>

                            {['top', 'bottom', 'left', 'right'].map((state, index) => (
                              <div className="col-md-2 text-center" key={index}>
                                <TextBox
                                  type="Number"
                                  id={state}
                                  name={state}
                                  label={state}
                                  value={this.state[state]}
                                  change={this.handleInputChange}
                                />
                              </div>
                            ))
                            }
                            {/* <div className="col-md-2 mt-4">
                              <Link to={'/LetterHeadList'} className="btn btn-sm btn-primary w-100">
                                letter head list
                              </Link>
                            </div> */}
                          </div>
                        </div>
                        {this.state.selectedImage ? (
                          <div>
                            <div className="card-body">
                              <p className="text-muted"></p>
                              <div
                                className="bubble-editor"
                                style={{
                                  position: "relative", width: '210mm', height: '297mm', position: 'absolute'
                                }}>
                                <div
                                  className="shadow"
                                  style={{
                                    height: "1.5px",
                                    width: "100%",
                                    borderTop: "2px dotted #666",
                                    position: "absolute",
                                    top: `${this.state.top}mm`,
                                    zIndex: "9",
                                  }}
                                ></div>
                                <div
                                  className="shadow"
                                  style={{
                                    height: "100%",
                                    width: "1.5px",
                                    borderLeft: "2px dotted #666",
                                    position: "absolute",
                                    left: `${this.state.left}mm`,
                                    zIndex: "9",
                                  }}
                                ></div>
                                <div
                                  className="shadow"
                                  style={{
                                    height: "100%",
                                    width: "1.5px",
                                    borderRight: "2px dotted #666",
                                    position: "absolute",
                                    right: `${this.state.right}mm`,
                                    zIndex: "9",
                                  }}
                                ></div>
                                <div
                                  className="shadow"
                                  style={{
                                    height: "1.5px",
                                    width: "100%",
                                    borderBottom: "2px dotted #666",
                                    position: "absolute",
                                    bottom: `${this.state.bottom}mm`,
                                    zIndex: "9",
                                  }}
                                ></div>
                                {this.state.selectedImage ? (
                                  <img
                                    src={this.state.selectedImage}
                                    alt="Selected Preview"
                                    style={{ width: "210mm", height: "297mm" }}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="card-body">
                            <h3 className="text-muted">Please Select Image...</h3>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
        </>
      );
    }
  }
);

export default withRouter(LetterHead);
